import axios from 'axios';

// Use relative URLs - the axios interceptor in axiosInterceptor.js handles auth headers
// and the proxy/production server handles routing to the correct backend
const API_BASE_URL = '/api/license';

const licenseService = {
  /**
   * Get current license information
   */
  getLicenseInfo: async () => {
    const response = await axios.get(`${API_BASE_URL}/info`);
    return response;
  },

  /**
   * Get license status (simple check)
   */
  getLicenseStatus: async () => {
    const response = await axios.get(`${API_BASE_URL}/status`);
    return response;
  },

  /**
   * Get machine ID for license generation (public endpoint - no auth required)
   */
  getMachineId: async () => {
    // This endpoint is public so license can be generated even before authentication
    const response = await axios.get(`${API_BASE_URL}/machine-id`);
    return response;
  },

  /**
   * Force refresh license information (admin only)
   */
  refreshLicense: async () => {
    const response = await axios.post(`${API_BASE_URL}/refresh`, {});
    return response;
  }
};

export default licenseService;
